// ============================================
// CONFIG - Alianzas con partners
// ============================================
// Fuente única de verdad para las landing pages de registro de partners
// (AlianzaRegisterPage). Agregar un partner nuevo: 1 logo + 1 entrada acá +
// 1 ruta en router.tsx + 1 constante en LeadSource.java (backend).
//
// `medioInformacion` y `monthsTrial` deben coincidir byte a byte / valor a
// valor con la constante correspondiente en
// Backend/.../security/domain/model/LeadSource.java — son dos repos con
// despliegue independiente, así que esta correspondencia no la valida el
// compilador, hay que mantenerla a mano en ambos lados.

import laSelectaLogo from '@/assets/logos/la-selecta.png';
import impulsoDigitalLogo from '@/assets/logos/impulso-digital.png';
import posCtaLogo from '@/assets/logos/pos-cta.png';
import tecnolineLogo from '@/assets/logos/tecnoline.webp';

export interface AlianzaConfig {
  /** Valor EXACTO enviado al backend en medioInformacion.
   *  Debe coincidir byte a byte con LeadSource.<X>.getValue() del backend. */
  medioInformacion: string;
  /** Nombre del partner tal como se muestra en pantalla. */
  displayName: string;
  /** Conjunción previa al nombre: 'e' antes de palabras que empiezan con i-/hi-. */
  conjuncion: 'y' | 'e';
  logo: string;
  /** Clases extra del logo grande (columna izquierda). */
  logoClassName?: string;
  /** Clases extra del logo del footer del formulario. */
  logoFooterClassName?: string;
  /** Clase del nombre del partner en el H2 del formulario. Default: 'text-blue-600'. */
  nameClassName?: string;
  /** Meses de trial PRO pactados. Debe coincidir con LeadSource.<X>.getMonthsTrial() del backend. */
  monthsTrial: number;
}

export const ALIANZAS = {
  selecta: {
    medioInformacion: 'La Selecta',
    displayName: 'La Selecta',
    conjuncion: 'y',
    logo: laSelectaLogo,
    nameClassName: "font-['Pacifico']",
    monthsTrial: 1,
  },
  impulsodigital: {
    medioInformacion: 'Impulso Digital',
    displayName: 'Impulso Digital',
    conjuncion: 'e',
    logo: impulsoDigitalLogo,
    monthsTrial: 1,
  },
  poscta: {
    medioInformacion: 'PosCta',
    displayName: 'PosCta',
    conjuncion: 'y',
    logo: posCtaLogo,
    monthsTrial: 1,
  },
  tecnoline: {
    medioInformacion: 'Tecnoline',
    displayName: 'Tecnoline',
    conjuncion: 'y',
    logo: tecnolineLogo,
    logoClassName: 'rounded-xl shadow-lg',
    logoFooterClassName: 'rounded-lg',
    monthsTrial: 1,
  },
} satisfies Record<string, AlianzaConfig>;
